module.exports = __webpack_public_path__ + "static/img/bg-pt.9fc2d89b.png";